import { useTranslation } from "react-i18next";

import { isNullOrEmptySpace } from "@ryde/shared";

import { CsvCellTransformerFn, ICsvColumnTransformer } from "./models";

export const useCsvBooleanCellTransformer = (): {
  getBooleanValue: CsvCellTransformerFn;
} => {
  const { t } = useTranslation();
  const yesTranslation = t("selectListLabel.Yes");
  const noTranslation = t("selectListLabel.No");

  const getBooleanValue = ({ value }: ICsvColumnTransformer): string => {
    return !isNullOrEmptySpace(value) && !!value
      ? yesTranslation
      : noTranslation;
  };

  return { getBooleanValue };
};
